declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

export function initMetaPixel(pixelId: string): void {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  const n: any = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  }
  window.fbq = n
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', pixelId)
  window.fbq('track', 'PageView')
}

export function trackEvent(
  eventName: string,
  params?: Record<string, any>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', eventName, params)
}
